{
  "app.title": "AoM Retold · Build Orders",
  "app.short": "Build Orders",
  "nav.library": "Library",
  "nav.settings": "Settings",
  "nav.back": "Back",
  "footer.legal": "Age of Mythology © Microsoft Corporation. This site is not affiliated with or endorsed by Microsoft.",
  "footer.fan": "Non-profit fan project.",
  "footer.reference": "* Results are a reference, not an exact measurement: Oracle favor, villager walking time and other factors vary from match to match.",
  "footer.source": "Open source on GitHub",
  "storage.unavailable": "Could not save in the browser. Export your builds so you don't lose them.",
  "loading": "Loading…",
  "error.data": "Could not load the game data",
  "library.mine": "My builds",
  "library.presets": "Standard builds",
  "library.empty": "No builds yet",
  "library.new": "New build",
  "library.import": "Import",
  "library.exportAll": "Export all",
  "library.drop": "Drop .json files here",
  "library.filters": "Filters",
  "library.all": "All",
  "library.noMatch": "Nothing matches these filters",
  "oss.title": "Open source",
  "oss.text": "This app is free, made by players, and all of its code is on GitHub. Found a bug, have an idea or want to help with the code or the game numbers? Come along.",
  "oss.repo": "See on GitHub",
  "oss.issue": "Suggest or report",
  "card.open": "Open",
  "card.duplicate": "Duplicate",
  "card.duplicateToEdit": "Duplicate to edit",
  "card.export": "Export",
  "card.exportDashboard": "Export for the dashboard",
  "share.copy": "Copy link",
  "share.copied": "Link copied: whoever opens it sees the build and can save a copy.",
  "share.copyManually": "Copy the link:",
  "share.banner": "Shared build",
  "share.save": "Save to my builds",
  "share.saved": "Build saved to your builds",
  "share.invalid": "Invalid or incomplete link.",
  "share.loading": "Opening the build…",
  "propose.menu": "Propose as standard build",
  "propose.confirm": "The build opens on GitHub as a public proposal (a GitHub account is needed). A bot checks the build and, if it passes, it goes to review; once approved, everyone sees it as a standard build.",
  "propose.go": "Open on GitHub",
  "propose.hasErrors": "The build has errors: fix them before proposing.",
  "card.delete": "Delete",
  "card.play": "Match mode",
  "mode.view": "Overview",
  "mode.edit": "Edit",
  "mode.play": "Match mode",
  "overview.full": "Full view",
  "card.confirmDelete": "Delete “{name}”?",
  "card.readonly": "Read-only",
  "confirm.yes": "Yes",
  "confirm.no": "No",
  "confirm.cancel": "Cancel",
  "type.rush": "Rush",
  "type.eco": "Economy",
  "type.timing": "Timing",
  "type.water": "Water",
  "type.other": "Other",
  "import.ok.one": "{count} build imported",
  "import.ok.other": "{count} builds imported",
  "import.error": "Invalid file: {detail}",
  "import.newer": "This file comes from a newer app version (v{version}). Reload the page.",
  "import.conflict": "A build with the id of “{name}” already exists.",
  "import.replace": "Replace",
  "import.keepBoth": "Keep both",
  "import.suffix": "(imported)",
  "editor.name": "Name",
  "editor.author": "Author",
  "editor.type": "Type",
  "editor.pantheon": "Pantheon",
  "editor.god": "Major god",
  "editor.minors": "Minor gods",
  "editor.objective": "Objective",
  "editor.end": "Build end",
  "editor.actions": "Actions",
  "editor.add": "Add action",
  "editor.result": "Result",
  "editor.settings": "Simulation",
  "editor.efficiency": "Efficiency",
  "editor.tick": "Tick (s)",
  "editor.foodChain": "Food chain",
  "editor.oracleRate": "Favor per Oracle (/min)",
  "editor.norseFavor": "Norse favor (/min)",
  "editor.readonly": "Standard build: read-only",
  "editor.empty": "Add actions from the palette",
  "editor.matchups": "Matchups",
  "editor.milestones": "Milestones",
  "editor.addMilestone": "Mark as milestone",
  "editor.removeMilestone": "Remove milestone",
  "picker.search": "Search action, event or time…",
  "picker.filter": "Show",
  "picker.all": "All",
  "picker.end": "Ends",
  "picker.start": "Starts",
  "picker.empty": "Nothing found",
  "picker.never": "Never happens",
  "picker.choose": "Pick an action…",
  "milestone.add": "Add milestone",
  "milestone.remove": "Remove milestone",
  "result.clickedAt": "Click: {t}",
  "help.milestone.add": "Pick a moment of the build to follow its time and resources: when an action **ends** (age reached, building done, units ready…) or when it **starts**.",
  "editor.saved": "Saved",
  "editor.notFound": "Build not found",
  "editor.changePantheon": "Changing the pantheon clears the actions. Continue?",
  "editor.reset": "Default",
  "palette.pick": "Pick",
  "palette.allAges": "All ages",
  "action.train": "Train",
  "action.train.auto": "Auto queue",
  "action.build": "Build",
  "action.research": "Research",
  "action.age": "Age up",
  "action.move": "Move villagers",
  "action.power": "God power",
  "action.timeShift": "Time Shift",
  "action.promote": "Promote",
  "action.event": "Manual event",
  "row.when": "When",
  "row.asap": "As soon as possible after…",
  "row.after": "After…",
  "row.afterDone": "When it ends",
  "row.afterStart": "When it starts",
  "row.atTime": "At time",
  "row.delay": "Delay (s)",
  "row.count": "Count",
  "row.trainMode": "Mode",
  "row.trainMode.count": "Fixed count",
  "row.trainMode.auto": "Auto queue",
  "row.duration": "For (s)",
  "row.rally": "Rally",
  "row.builder": "Builder",
  "row.builderNew": "New villager from…",
  "row.builderFrom": "Take from",
  "row.builderSame": "Same builder as…",
  "row.then": "Then goes to",
  "row.from": "From",
  "row.to": "To",
  "row.nearManor": "Manors nearby",
  "row.target": "Target",
  "row.trainAt": "Building",
  "row.lose": "Lose",
  "row.gainFavor": "Gain favor",
  "row.gainResource": "Gain resource",
  "row.note": "Note",
  "row.up": "Move up",
  "row.down": "Move down",
  "row.drag": "Drag to reorder",
  "row.remove": "Remove",
  "row.duplicate": "Duplicate action",
  "row.edit": "Edit",
  "row.unit": "Unit",
  "row.any": "Any",
  "row.minor": "Minor god",
  "row.started": "Started {t}",
  "row.done": "Finished {t}",
  "row.notStarted": "Did not start",
  "row.none": "—",
  "result.timeline": "Timeline",
  "result.resources": "Resources",
  "result.population": "Population",
  "result.warnings": "Warnings",
  "result.noWarnings": "No warnings",
  "result.used": "Used",
  "result.cap": "Cap",
  "result.time": "Time",
  "result.pop": "Pop.",
  "result.alloc": "Villagers: food/wood/gold/favor",
  "result.good": "Good",
  "result.neutral": "Neutral",
  "result.bad": "Bad",
  "result.lowConfidence": "Low-confidence data",
  "result.clicked": "Click",
  "result.reached": "Reached",
  "res.food": "Food",
  "res.wood": "Wood",
  "res.gold": "Gold",
  "res.favor": "Favor",
  "res.idle": "idle",
  "res.any": "any resource",
  "word.or": " or ",
  "step.train": "Train {count} {unit}",
  "step.ready": "+1 {unit} → {to}",
  "step.readyMilitary": "+1 {unit}",
  "step.build": "Build {building}",
  "step.builderFrom.one": "from {from}",
  "step.builderFrom.other": "{count} from {from}",
  "step.byNew": "new {unit}",
  "step.bySame": "same builder",
  "step.byFrom": "1 {unit} from {from}",
  "step.buildDone": "{building} ✓ · builder → {to}",
  "step.buildDoneAlone": "{building} ✓",
  "step.research": "Research {research}",
  "step.researchDone": "{research} ✓",
  "step.age": "Research {age} ({minor})",
  "step.ageDone": "{age} ✓",
  "step.ageDoneFree": "{age} ✓ · {free} free",
  "step.move": "{count} {worker} from {from} → {to}",
  "step.power": "{power}",
  "step.powerOn": "{power} → {target}",
  "step.timeShift": "Time Shift: {building} ({seconds} s)",
  "step.timeShiftDone": "{building} arrived",
  "step.promote": "Promote {count} {unit} → {to}",
  "step.autoTrain": "Auto queue {unit}",
  "step.autoTrainFor": "Auto queue {unit} for {time}",
  "step.autoTrainUntil": "Auto queue {unit} until {until}",
  "step.autoTrainEnd": "Auto queue of {unit} ends",
  "step.lose": "−{count} {unit}",
  "step.gain": "+{count} {resource}",
  "warn.noResource": "Not enough {resource} ({missing}); waited {waited} s",
  "warn.queueBusy": "Queue busy: {building}; waited {waited} s",
  "warn.popCapped": "Population capped ({unit}); waited {waited} s",
  "warn.missingRequirement": "Missing requirement: {req}",
  "warn.waitingRequirement": "Waited for {req}: {waited} s",
  "warn.lowConfidenceData": "Low-confidence data: {id}",
  "warn.unknownId": "Unknown id: {id}",
  "warn.unknownAction": "Referenced action does not exist: {id}",
  "warn.noBuilding": "No building can do this",
  "warn.buildingNotReady": "{building} not ready; waited {waited} s",
  "warn.noWorker": "No villager on {from}; waited {waited} s",
  "warn.noBuilder": "Builder unavailable ({id})",
  "warn.waitingBuilder": "Waiting for builder",
  "warn.notEnoughWorkers": "Only {moved} of {wanted} villagers on {from}",
  "warn.notEnoughUnits": "Only {removed} of {wanted}: {unit}",
  "warn.buildLimit": "Limit reached: {building}",
  "warn.alreadyResearched": "Already researched: {id}",
  "warn.invalidMinor": "{minor} is not available for {age}",
  "warn.alreadyInAge": "Already in age: {age}",
  "warn.powerUnavailable": "Power unavailable: {power}",
  "warn.powerNoUses": "{power} has no uses left",
  "warn.powerCooldown": "{power} on cooldown; waited {waited} s",
  "warn.missingTarget": "{power} needs a target",
  "warn.cannotPromote": "Cannot be promoted: {unit}",
  "warn.noUnitToPromote": "Nothing to promote ({unit}); waited {waited} s",
  "warn.cannotGather": "{unit} does not gather {source}",
  "warn.idleWorkers": "Idle villagers for {waited} s",
  "warn.neverStarted": "The action never started",
  "level.info": "Info",
  "level.delay": "Delay",
  "level.error": "Error",
  "match.start": "Start",
  "match.pause": "Pause",
  "match.reset": "Reset",
  "match.minus5": "−5 s",
  "match.plus5": "+5 s",
  "match.countdown": "Countdown (s)",
  "match.sound": "Countdown sound for each action",
  "match.now": "Now",
  "match.next": "Next",
  "match.done": "End of build",
  "match.exit": "Leave match mode",
  "match.workers": "Villagers now",
  "match.notStarted": "The build has not started yet.",
  "settings.language": "Language",
  "settings.theme": "Theme",
  "settings.themeLight": "Light",
  "settings.themeDark": "Dark",
  "settings.themeSystem": "System",
  "settings.efficiency": "Default efficiency",
  "settings.sound": "Match mode sound",
  "settings.on": "On",
  "settings.off": "Off",
  "settings.data": "Game data",
  "settings.patch": "Game patch",
  "settings.api": "Static API",
  "step.byUnit": "1 {unit}",
  "row.builderUnit": "Soldier",
  "warn.cannotBuild": "{unit} cannot build {building}",
  "warn.noUnitToBuild": "No {unit} available; waited {waited} s",
  "settings.tooltips": "Help tips",
  "help.library.new": "Creates an empty build and opens the editor.",
  "help.library.import": "Loads builds from a .json file exported by this site.",
  "help.library.exportAll": "Downloads all your builds in a single .json file (backup).",
  "help.library.all": "Clears the pantheon and god filter.",
  "help.library.drop": "Drag .json files here to import builds.",
  "help.library.mine": "Builds you created, saved in this browser.",
  "help.library.presets": "Ready-made builds that ship with the site. Read-only: duplicate to edit.",
  "help.type.rush": "Early attack to pressure the opponent.",
  "help.type.eco": "Economy focus: many villagers before fighting.",
  "help.type.timing": "A strong attack at a planned moment (e.g. right after an age up).",
  "help.type.water": "Build for water maps (fishing and ships).",
  "help.type.other": "Any other kind of build.",
  "help.editor.objective": "The build's plan in a few words: what it tries to achieve.",
  "help.editor.end": "Where the build ends: an attack, an age, a unit. After that the game is up to you.",
  "help.editor.settings": "Simulation parameters for this build. Empty = default value.",
  "help.editor.efficiency": "How much of the theoretical gather rate villagers really achieve (walking, drop-off). 1 = 100%.",
  "help.editor.tick": "Simulation step in seconds. Smaller = more precise and slower.",
  "help.editor.oracleRate": "Favor per minute of each Oracle (0.6 moving to 3.4 standing with clear sight). The hero gives 44% more.",
  "help.editor.norseFavor": "The Norse earn favor by fighting. Estimate here the favor per minute from combat.",
  "help.editor.foodChain": "Order of food sources. Villagers sent to “food” use the first one that still has food.\n• **Drag** to reorder.\n• **Hunt, herd and berries** can come again (e.g. a second hunt), each with its own amount.\n• When one runs out, the build gets an automatic step to send the villagers to the next.",
  "help.editor.actions": "The build steps in order, each with its bar in time: dashed is waiting, a diamond is instant. Drag the handle to reorder, drag the bar to change the time, click to see the details.",
  "help.editor.add": "Pick the action type, then the unit, building or research. Click to add it at the end, or drag it to a position in the list.",
  "help.editor.milestones": "Key moments: time and resources at each.",
  "help.editor.matchups": "How the build fares against each god. Drag the portraits between columns, or click to change the rating.",
  "help.palette.allAges": "Shows items of every age. Use the icons to filter by age.",
  "help.action.train": "Trains units at a building. The cost is paid when each unit starts.\n**Mode**:\n• **fixed count**: N units\n• **auto queue**: nonstop for the time in **For**",
  "help.action.train.auto": "Auto queue: the building trains the unit nonstop while resources last.\n• Spends whatever is available, even if other actions are delayed.\n• No other action holds it back: whenever the building is free and the stock pays, it trains one more.\n• Stays on for the time in **For** (or to the end of the build).",
  "help.action.build": "Builds a building with one or more villagers.",
  "help.action.research": "Researches a technology at a building.",
  "help.action.age": "Ages up, choosing the minor god.",
  "help.action.move": "Moves villagers from one resource to another.",
  "help.action.power": "Uses a god power.",
  "help.action.timeShift": "Moves a finished building elsewhere. It takes the building's build time; Palace, Sentry Tower and Mirror Tower cost 50% of their price. At most 2 at once.",
  "help.action.promote": "Turns a unit into another.",
  "help.action.event": "Something the simulation does not compute: losing units in a raid, gaining favor or resources, or a note.",
  "help.row.when": "When the action starts: at a fixed time, right after another action, or as soon as possible from another action.",
  "help.row.count": "How many units (or villagers).",
  "help.row.rally": "Where villagers go when they leave the building.",
  "help.row.target": "Which building gets the effect.",
  "help.row.trainAt": "Which building trains it. “Any” uses the first free one.",
  "help.row.builder": "Who builds, as you pick in the game:\n• **Take from…**: a villager gathering a resource (or idle).\n• **New villager from…**: one from an earlier training.\n• **Same builder as…**: whoever built an earlier building.\n• **Soldier**: a military unit that builds (e.g. Norse infantry).",
  "help.row.unit": "Which unit.",
  "help.row.trainMode": "How training goes on:\n• **Fixed count**: trains N units and is done.\n• **Auto queue**: trains nonstop while resources last, for the time in **For**; may delay other actions.",
  "help.row.from": "Which resource the villagers leave.",
  "help.row.to": "Which resource the villagers go to.",
  "help.row.then": "Where the builder goes when finished.",
  "help.row.nearManor": "Kronos: how many Manors are near the building. Each one speeds up construction by 25%.",
  "help.row.minor": "The minor god chosen on this age up.",
  "help.row.lose": "Units lost (e.g. in a raid). They free population.",
  "help.row.gainFavor": "Favor gained at once (e.g. Norse fighting).",
  "help.row.note": "A reminder shown on the timeline.",
  "help.row.mode.time": "Starts at the given time (m:ss).",
  "help.row.mode.asap": "Starts as soon as it can (resources, a free building) from a moment of another action:\n• **when it ends**\n• **when it starts**\nWaiting here is expected: it does not count as a delay.",
  "help.row.mode.after": "Starts right at a moment of another action, plus the delay:\n• **when it ends**: age reached, building done, units ready…\n• **when it starts**\nWaiting for resources is a delay.",
  "help.result.timeline": "The build second by second: time, actions, population and villagers on food/wood/gold/favor.",
  "help.result.warnings": "Problems found by the simulation. Click a warning to jump to the action.",
  "help.result.resources": "Stored resources over time.",
  "help.result.population": "Population used and cap over time.",
  "help.result.clicked": "When the age up was clicked.",
  "help.result.reached": "When the new age was reached.",
  "help.result.good": "Matchups where the build is strong.",
  "help.result.neutral": "Even matchups.",
  "help.result.bad": "Matchups where the build struggles.",
  "help.level.error": "The action cannot happen as written (missing requirement, wrong id…).",
  "help.level.delay": "The action was delayed: missing resources, busy queue, population full…",
  "help.level.info": "Information: low-confidence data, a resource the unit does not gather…",
  "help.match.countdown": "Countdown seconds before 0:00, to sync with the start of the match.",
  "help.match.now": "The current step of the build.",
  "help.match.next": "The next 3 actions and how long until each.",
  "help.match.reset": "Puts the clock back to the start.",
  "help.settings.language": "Site language.",
  "help.settings.theme": "Light, dark or the same as your system.",
  "help.settings.efficiency": "Efficiency used for new builds.",
  "help.settings.sound": "Beep in match mode 3 s before each step.",
  "help.settings.tooltips": "Shows these explanations when hovering titles.",
  "help.settings.data": "Where the game numbers come from.",
  "help.settings.patch": "Game version used for the data.",
  "help.settings.api": "JSON files with the standard builds and the data, for other sites to use.",
  "tab.details": "Details",
  "help.tab.details": "Type, author, objective, build end, simulation parameters and matchups.",
  "production.title": "Production",
  "help.production.title": "What each building is doing over time: training, research, age up, construction and Time Shift. Hover a bar to see start and end.",
  "production.zoom": "Zoom",
  "production.building": "Construction: {building}",
  "production.shift": "Time Shift",
  "production.running": "running",
  "production.held": "Ready, waiting for population since {t}",
  "production.heldLegend": "Waiting for population",
  "production.kind.unit": "Training",
  "production.kind.research": "Research",
  "production.kind.age": "Age",
  "production.kind.build": "Construction",
  "production.kind.shift": "Time Shift",
  "warn.cannotTimeShift": "This building cannot be Time Shifted: {building}",
  "warn.timeShiftLimit": "At most {count} Time Shifts at once; waited {waited} s",
  "action.promote.atlanteans": "Promote to hero",
  "help.action.promote.atlanteans": "Turns the unit into a hero: stronger; a Citizen hero gathers and builds faster. A villager stops gathering for the 7 s of the promotion.",
  "help.action.promote.gaia": "Turns the unit into a hero. Gaia: the Citizen hero costs 25% less. A villager stops gathering for the 7 s of the promotion.",
  "action.promote.norse": "Turn into Berserk",
  "help.action.promote.norse": "Turns a Gatherer (30 food + 20 gold) or a Dwarf (10 food + 30 gold) into a Berserk instantly. It stops gathering and joins the army. Needs 1 free population slot (a Berserk takes 2).",
  "help.action.promote.loki": "Turns a Gatherer or Dwarf into a Berserk instantly. Loki: half price (Gatherer 15 food + 10 gold; Dwarf 5 food + 15 gold). Needs 1 free population slot (a Berserk takes 2).",
  "help.action.build.norse": "Builds a building. Gatherers and Dwarves only build House, Farm and Ox Cart; everything else is built by infantry (pick the “Soldier” builder).",
  "help.row.builder.norse": "Who builds: Automatic, Take from a resource, New villager from an earlier training, Same builder as an earlier construction, or a Soldier (Berserk, Hersir…) for buildings Gatherers and Dwarves cannot build.",
  "action.empower": "Empower",
  "action.summon": "Summon animal",
  "step.empower": "Empower {building} ({unit})",
  "step.summon": "Summon {count} {unit}",
  "step.hunted": "{unit} hunted: +{food} food in the hunt",
  "row.by": "By",
  "row.slot": "Which (#)",
  "row.huntIt": "Hunt it",
  "warn.cannotEmpower": "{unit} cannot empower {building}",
  "warn.noUnitToEmpower": "No {unit} free to empower; waited {waited} s",
  "warn.cannotSummon": "This god cannot summon {unit}",
  "warn.notForGod": "This god does not have: {id}",
  "help.action.empower": "The Pharaoh empowers one building at a time: construction, research (age ups included) and military training ×1.75; resources dropped at the dropsite ×1.2; Monument favor ×1.2. Laborers, fishing ships and caravans do not train faster.",
  "help.action.empower.ra": "Ra: the Pharaoh empowers one building at a time (construction, research and military training ×1.75; dropsite and Monument favor ×1.2) and each Priest empowers one more building at 60% strength (×1.45 and ×1.12). Effects do not stack: on the same building the strongest counts.",
  "help.action.empower.isis": "Isis: the Pharaoh empowers one building at a time (construction, research and military training ×1.75; dropsite ×1.2). An empowered Monument makes double favor (×2).",
  "help.action.summon": "Summons an animal with favor.",
  "help.action.summon.set": "Set: the Pharaoh summons Animals of Set with favor (Baboon 3, Gazelle 3, Giraffe 5…). Tick “Hunt it” to kill the animal and add its food to the hunt (Gazelle 150, Giraffe 300).",
  "help.row.by": "Who empowers: the Pharaoh.",
  "help.row.by.ra": "Who empowers: the Pharaoh (full effect) or a Priest (60% strength).",
  "help.row.slot": "Which Pharaoh/Priest (1, 2, …). Each empowers one building; empowering another one moves it.",
  "help.row.huntIt": "Kills the animal as soon as it appears: it takes no population and its food goes to the hunt.",
  "help.action.train.greeks": "Trains units at a building. Greek heroes have their own queue: they train without stopping villagers or the age up.\n**Mode**:\n• **fixed count**: N units\n• **auto queue**: nonstop for the time in **For**",
  "help.action.research.thor": "Researches a technology. Thor: no Armory; each Dwarven Armory research gives 1 free Dwarf.",
  "help.action.build.loki": "Builds a building. Gatherers and Dwarves only build House, Farm and Ox Cart; everything else is built by infantry, which builds 10% faster with Loki.",
  "editor.undo": "Undo (Ctrl+Z)",
  "editor.redo": "Redo (Ctrl+Y)",
  "row.builderNewFrom": "Training action",
  "row.builderSameAs": "Earlier construction",
  "row.invalidRef": "action not found before this one",
  "help.row.builderNewFrom": "Which earlier training action provides the villager that will build. The action waits for that villager to be ready (e.g. “Train 3 Citizens” → the next one out builds).",
  "help.row.builderSameAs": "Which earlier construction: the same villager builds this one as soon as it finishes the other.",
  "nav.close": "Close",
  "editor.more": "More",
  "tab.gods": "Gods",
  "tab.actions": "Actions",
  "tab.result": "Result",
  "help.tab.gods": "Pick the pantheon, the major god and one minor god per age.",
  "help.tab.actions": "Build it with the palette. Each action shows when it starts in the simulation.",
  "help.tab.result": "Milestones, what each building produces and the resource and population charts.",
  "help.editor.minors": "The minor god picked when advancing to each age.",
  "editor.start": "Match start",
  "editor.startIdle.one": "{count} starting villager is idle: use Move (from idle).",
  "editor.startIdle.other": "{count} starting villagers are idle: use Move (from idle).",
  "warn.idleUntilEnd.one": "{count} villager stayed idle until the end",
  "warn.idleUntilEnd.other": "{count} villagers stayed idle until the end",
  "help.production.zoom": "Zoom from the whole build on screen: 2× makes everything twice as wide (half the build fits on screen), 4× four times.",
  "palette.group.economy": "Economy",
  "palette.group.god": "God",
  "palette.group.other": "Other",
  "help.palette.group.economy": "The basics of every build: move villagers, train (fixed count or auto queue), build, research and age up.",
  "help.palette.group.god": "Powers and actions that depend on the chosen god.",
  "help.palette.group.other": "Notes on the timeline, such as a raid or lost units.",
  "wd.waited": "Waited {waited} s",
  "wd.need": "Cost",
  "wd.have": "Had at {t}",
  "wd.missing": "Missing",
  "wd.gathering": "Gathering",
  "wd.gatherers.one": "{count} villager",
  "wd.gatherers.other": "{count} villagers",
  "wd.spent": "{resource} spent during the wait",
  "wd.noSpent": "None: the wait was gathering only.",
  "wd.other": "Other",
  "wd.onlyGathering": "Gathering only, the missing {missing} {resource} take ~{s} s.",
  "wd.spentDelay": "The spends above ({total}) added ~{s} s to the wait.",
  "wd.goTo": "Go to the action",
  "help.warn.noResource": "The action was ready, but the stock could not pay the cost; it waits until gathering covers the gap. To speed it up: put more villagers on that resource earlier or spend less of it before.",
  "help.warn.queueBusy": "The building was busy training or researching something else; the action starts when the queue frees up.",
  "help.warn.popCapped": "The unit was ready, but population was capped: it only leaves when there is room. Raise the population earlier.",
  "help.warn.waitingRequirement": "The action depends on something that was not ready yet (building, age or research) and waited for it.",
  "help.warn.missingRequirement": "A requirement (building, age or minor god) is never created by the build; the action does not start.",
  "help.warn.idleWorkers": "Villagers had nothing to do in this period. Use Move to send them gathering.",
  "help.warn.idleUntilEnd": "Villagers had nothing to do until the end of the simulation. Use Move (from idle) to send them gathering.",
  "help.warn.neverStarted": "The action never started before the simulation ended. The reason shown is what held it last.",
  "help.warn.lowConfidenceData": "A number used here is uncertain in the data; the real match may differ.",
  "help.warn.waitingBuilder": "No builder was free; the construction waited for one to finish.",
  "help.warn.notEnoughWorkers": "Asked to move more villagers than that task had at the time.",
  "help.warn.powerCooldown": "The power was still recharging since its last use.",
  "editor.matchupPool": "Unrated gods",
  "editor.clearMinorLater": "Removing this age up also removes the later ages ({ages}). Continue?",
  "help.editor.chainItem": "Drag to change the priority (or use ← →). Drag it down, out of the list, to remove it.",
  "help.editor.matchupGod": "Changes the rating or the order:\n• **Click**: changes the rating.\n• **Drag to a column**: goes to its end.\n• **Drag onto another god** or use **← →**: changes the order within the group.",
  "help.editor.minorChosen": "Picked. Click again to remove it (the build does not reach this age).",
  "help.editor.minorPick": "Click to pick this minor god when aging up.",
  "tl.workers": "Villagers",
  "tl.stock": "Stock",
  "tl.building": "building",
  "tl.lanes": "Buildings",
  "tl.fit": "Fit",
  "tl.dragHint": "Drag to change the time",
  "help.tl.workers": "What villagers are doing over time, by resource. Hover to see the numbers and population.",
  "help.tl.lanes": "One row per building with what it trains, researches or builds, on the same time axis.",
  "help.tl.fit": "Shows the whole build in the screen width.",
  "step.depletedIdle": "{source} depleted → villagers idle",
  "warn.sourceDepletedIdle": "{source} depleted → villagers idle",
  "help.warn.sourceDepletedIdle": "The source ran out and no other food in the chain is available: the villagers stay idle until you send them elsewhere.",
  "help.mode.view": "The whole build at once: timeline, resources and villagers, nothing to edit.",
  "help.mode.edit": "Create or change the build: actions, gods, settings.",
  "help.mode.play": "Follow the build during a match with a timer.",
  "help.overview.full": "Checked, shows everything:\n• timeline with villagers and events\n• production by building\n• resources and population\nUnchecked: only the ages and the order of the actions.",
  "help.match.workers": "Where the villagers should be right now according to the build, and the population. Compare with the game to spot what you forgot.",
  "help.row.duration": "How long the auto queue stays on, in seconds, counted from when the action starts.\n• **Empty**: to the end of the build.",
  "editor.chainAmount": "Amount",
  "help.editor.chainAgain": "Click to add it to the chain again: e.g. a second hunt, with its own amount.",
  "step.shift": "{source} depleted: {count} {worker} → {next}",
  "step.shiftAgain": "{source} depleted: {count} {worker} → next {source}",
  "step.auto": "manual in game",
  "help.step.auto": "Automatic step: the simulator does this by itself when the source runs out, so it is not in the action list.\n• **In the game** villagers do not move by themselves: select them and send them.\n• The simulation assumes you did it right away.",
  "editor.events": "Events",
  "help.editor.events": "Shows between the actions what happens on its own: units ready, buildings done, ages reached.\n• Automatic steps (✋, e.g. hunt depleted) always show: in the game you have to do them.",
  "row.powerNote": "How to use",
  "help.row.powerNote": "A note on how to use the power, shown with the action in the build and in Match mode.\n• E.g. on which unit, building or place.",
  "row.powerNoteExample": "e.g. on a citizen gathering gold",
  "match.previous": "Previous",
  "help.match.previous": "The step that just went by: if you are running a little late, it is still here.",
  "help.oss.repo": "Code, game data and project history. A star helps other players find it.",
  "help.oss.issue": "Opens a GitHub issue: a wrong number, something that does not work or a new idea."
}
